"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
var MetadataField;
(function (MetadataField) {
    MetadataField["CONTENT_TYPE"] = "contentType";
    MetadataField["CONTENT_LENGTH"] = "contentLength";
    MetadataField["WIDTH"] = "width";
    MetadataField["HEIGHT"] = "height";
    MetadataField["DURATION"] = "duration";
    MetadataField["FILENAME"] = "filename";
})(MetadataField = exports.MetadataField || (exports.MetadataField = {}));
exports.isFileSubjectDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "FileSubjectDetails";
};
class FileProvider extends DataProvider_1.default {
    get fragments() {
        return {
            FileUploadResponse: () => `
        ... on FileUploadResponse {
          urlPart
          uuid
        }
      `,
            File: () => `
        ... on File {
          fileId {
            subjectId
            type
            fileNumber
          }
          urlPart
          uuid
          updateTime
          contentType
          processingStatus
          metadata
        }
      `,
            SubjectDetails: () => `
        ... on FileSubjectDetails {
          file {
            ${this.getFragment("File")}
          }
        }
      `,
        };
    }
    find({ fileIds }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query FileFind($fileIds: [InputFileId]!) {
          fileFind(fileIds: $fileIds) {
            ${this.getFragment("File")}
          }
        }
      `,
                variables: { fileIds },
            });
            return response.data.fileFind;
        });
    }
    search({ data }) {
        return this.query("fileSearch", { data }, this.getFragment("File"));
    }
    getUploadUrl({ fileIds }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query FileGetUploadUrl($fileIds: [InputFileId]!) {
          fileGetUploadUrl(fileIds: $fileIds) {
            fileId {
              subjectId
              type
            }
            fileUpload {
              ${this.getFragment("FileUploadResponse")}
            }
          }
        }
      `,
                variables: { fileIds },
            });
            return response.data.fileGetUploadUrl;
        });
    }
    update({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation FileUpdate($data: InputFileUpdate!) {
          fileUpdate(data: $data) {
            ${this.getFragment("File")}
          }
        }
      `,
                variables: { data },
            });
            return response.data.fileUpdate;
        });
    }
    delete({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation FileDelete($data: InputFileId!) {
          fileDelete(data: $data)
        }
      `,
                variables: { data },
            });
            return response.data.fileDelete;
        });
    }
    getPublicFileUploadUrl({ fileName }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("publicFileGetUploadUrl", { fileName });
        });
    }
}
exports.FileProvider = FileProvider;
//# sourceMappingURL=FileProvider.js.map